<template>

<core-modal v-on:close="onClose" icon="caret-left">

	<template v-slot:head>

		Edit Tag

	</template>

	<template v-slot:default>

		<core-form-input-textbox :autofocus="true" maxlength="16" name="text" v-on:validate="validate" placeholder="Enter tag" v-model="inputs.text" notes="Maximum of 16 characters." :error="is.error" :disabled="is.loading" :validation="validation.text" />

		<core-form-input-colourpicker title="Background" name="colour" v-on:validate="validate" v-model="inputs.colour" :error="is.error" :disabled="is.loading" :validation="validation.colour" v-if="needStyle" />

		<core-form-input-colourpicker title="Text" name="fore" v-on:validate="validate" v-model="inputs.fore" :error="is.error" :disabled="is.loading" :validation="validation.fore" :is-text="true" v-if="needStyle" />

		<core-form-input-togglelist title="Seen by" name="public" v-on:validate="validate" v-model="inputs.public" :error="is.error" :disabled="is.loading" :validation="validation.public" :options="publicOptions" v-if="!isFamily" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!is.valid">Save changes</core-button>

		<core-button theme="red" v-on:click.native="onDeleteClick">Delete tag</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	props: ['data'],
	
	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			inputs: {
				text: '',
				family: 0,
				public: 1,
				colour: '#134677',
				fore: '#ffffff'
			},

			validation: {
				text: {
					exists: true,
					max: 16
				}
			}

		}

	},

	created: function() {

		this.inputs.family = this.tag.family
		this.inputs.text = this.tag.text
		this.inputs.public = this.tag.public
		this.inputs.colour = this.tag.colour
		this.inputs.fore = this.tag.fore

	},

	computed: {

        family: function() {

            return (this.isFamily) ? this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.inputs.family

            }.bind(this)) : false

        },

		isFamily: function() {

			return this.inputs.family

		},

		needStyle: function() {

			return !this.isFamily || !this.family.style

		},

		tag: function() {

			return this.$store.getters['data/tags'][this.data.tag]

		},

		publicOptions: function() {

			return [{
				value: 1,
				title: 'Everyone',
				text: 'Anyone viewing your profile can see this tag and filter with it.'
			}, {
				value: 0,
				title: 'Only me',
				text: 'Only you can see this tag and filter with it.'
			}]

		}

	},

	methods: {

		onConfirmClick: function() {

			if (this.is.valid) {

				this.is.loading = true

				this.$store.dispatch('api/tags/update', {
					tag: this.data.tag,
					data: this.inputs
				}).then(function(tag) {

					this.$store.commit('data/tags/update', [tag])

					this.onClose()

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this)) 

			}

		},

		onDeleteClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagDelete',
				tag: this.data.tag
			})

		},

		onClose: function() {

			this.$emit('close')
			
			if (this.isFamily) {

				this.$pubsub.$emit('open.modal', {
					id: 'tagFamilyManage',
					family: this.inputs.family
				})

			} else {
				
				this.$pubsub.$emit('open.modal', 'tagManage')

			}

		}

	}

}

</script>

<style scoped>

</style>